module.exports = __webpack_public_path__ + "img/robot-agent-icon.c14e1f7f.svg";